import { format, isPast, parse } from 'date-fns';
import pt from 'date-fns/locale/pt-BR';

// import { getCustomerCep } from '../redux/utils/cookies';

export const toBase64 = (file, onLoading) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();

    if (onLoading) {
      reader.onloadstart = onLoading;
      reader.onloadend = onLoading;
    }

    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

export const removeAccents = (str) => {
  if (str) {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  return str;
};

export const onlyNumber = (str) => str.replace(/\D|\W/g, '');

export const formatCep = (cep) => {
  if (cep && cep.indexOf('-') !== -1) {
    return cep;
  }

  return cep ? cep.slice(0, 5).concat('-', cep.slice(-3)) : null;
};

export const corrigeUrl = (str) => {
  if (str) {
    // eslint-disable-next-line no-param-reassign
    str = removeAccents(str.toLowerCase().replace(/\s/g, '-'));
  }
  return str;
};

/**
 * Função para formatar o erro e retornar apenas o necessário.
 *
 * @param {object} error erro padrão do catch.
 * @returns {object} retorna uma objeto com três propriedades, url, status e message.
 */
export const formatError = (error) => {
  let mountedError = {};

  if (typeof error === 'object') {
    mountedError = error;

    if (error.message && typeof error.message !== 'string') {
      mountedError = {
        ...error,
        message: null,
        messages: error.message,
        statusCode: error.statusCode,
      };
    }
  }

  if (typeof error === 'string') {
    mountedError = { message: error };
  }

  return mountedError;
};

export const getTarget = (target) => {
  let responseTarget = '_self';

  switch (target) {
    case 'Abrir na mesma aba':
      responseTarget = '_self';

      break;
    case 'Abrir em uma nova aba':
      responseTarget = '_blank';

      break;
    default:
      break;
  }

  return responseTarget;
};

export const slugify = (name) => {
  if (!name) {
    return null;
  }

  return removeAccents(name.toLowerCase())
    .replace(/&/g, 'e')
    .replace(/[^._a-zA-Z0-9]/g, '-')
    .replace(/-{2,}/g, '-');
};

export const mediaQueries = {
  smDefault: ({ theme }) => theme.breakpoints.sm.default,
  smMin: ({ theme }) => theme.breakpoints.sm.min,
  mdMin: ({ theme }) => theme.breakpoints.md.min,
  mdMaterial: ({ theme }) => theme.breakpoints.md.material,
  default: ({ theme }) => theme.breakpoints.default,
  smTablet: ({ theme }) => theme.breakpoints.sm.tablet,
  mdDefault: ({ theme }) => theme.breakpoints.md.default,
  smMaterial: ({ theme }) => theme.breakpoints.sm.material,
  xsPhone: ({ theme }) => theme.breakpoints.xs.phone,
  ldDefault: ({ theme }) => theme.breakpoints.ld.default,
  ldLandscape: ({ theme }) => theme.breakpoints.ld.landscape,
};

export const captalize = (text) => {
  if (!text) {
    return text;
  }

  const words = text.toLowerCase().split(' ');

  for (let a = 0; a < words.length; a++) {
    const w = words[a];
    words[a] = (w[0] ? w[0].toUpperCase() : '') + w.slice(1);
  }
  return words.join(' ');
};

/**
 * Função que faz um merge dos itens do carrinho e dos kits.
 *
 * @param {array} lines array de itens do carrinhho;
 * @param {array} kits array de kits do carrinhho;
 * @returns {array} retorna um array de itens e kits do carrinho em um mesmo nível com uma propriedade a mais dentro
 * de cada kit chamado 'items' que contém os itens pertecentes àquele kit.
 */
export const mergeLinesKits = (lines = [], kits = []) => {
  const merge = kits.map((kit) => ({
    ...kit,
    items: lines.filter((item) => item.idKit === kit.id),
    isKit: true,
  }));

  const filtered = lines.filter((item) => !item.idKit);

  return [...filtered, ...merge];
};

export const formatMoney = (number, prefix = true, zeroResult = false) => {
  const moneySymbol = prefix ? 'R$' : '';

  if (number) {
    const formatNumber = number.toFixed(2).split('.');
    formatNumber[0] = `${moneySymbol} ${formatNumber[0].split(/(?=(?:...)*$)/).join('.')}`;
    return formatNumber.join(',');
  }

  if (number === 0 && !zeroResult) {
    return 'Grátis';
  }

  return `${moneySymbol} 0,00`;
};

/**
 * Função que é passada como parâmetro ao método sort de um array de objetos que possuem uma propriedade 'type',
 * serve para reposicionar
 *  os objetos de forma padronizada.
 */
export const compareByType = (a, b) => {
  if (a.type > b.type) {
    return 1;
  }
  if (a.type < b.type) {
    return -1;
  }
  return 0;
};

/**
 * Função que valida a formatação da font, bold ou normal,
 * deve ser utilizada na propriedade CSS font-family, não na font-weight.
 *
 * @param {boolean} isBold úncio parâmetro é um boolean, se verdadeiro retorna font bold se não font normal;
 */
export const getFontWeight = (isBold) => (isBold ? 800 : 400);

/**
 * @returns {string} Retorna a cor primária do theme,
 * dever ser usada dentro do template string do styled "${getColorPrimary}"
 * caso queira utiliza-la fora do styled-components,
 * deve passr como parâmetro um objeto com o "theme" dentro, obj.theme.
 */
export const getColorPrimary = ({ theme }) => theme.colors.primary;
export const getColorSecondary = ({ theme }) => theme.colors.secondary;
export const getColorHeader = ({ theme }) => theme.colors.header;
export const getBodyColor = ({ theme }) => theme.colors.body;
export const fontFamily = ({ theme }) => (theme?.template === 'B' ? 'Inter' : 'Montserrat');
export const DEFAULT_SHADOW = '0px 1px 3px #00000030';

/**
 * Cria um Link para o produto.
 *
 * @param {string} name primeiro parâmetro é o nome do produto;
 * @param {string} id segundo parâmetro é o id do produto;
 * @param {array} params terceiro parâmetro monta a query string com base na grade do produto;
 * @returns {string} retorna um link para o produto no formato name-p-id.
 */
export const createProductLink = (name, id, params) => {
  let qs = '';

  const validParams = (params || []).filter((item) => item);

  if (validParams.length) {
    qs = `?${validParams.map((item) => `${item.type}=${item.value}`).join('&')}`;
  }

  return `/${slugify(name)}-p-${id}${qs}`;
};

export const UFs = [
  {
    name: 'Acre',
    value: 'AC',
  },
  {
    name: 'Alagoas',
    value: 'AL',
  },
  {
    name: 'Amapá',
    value: 'AP',
  },
  {
    name: 'Amazonas',
    value: 'AM',
  },
  {
    name: 'Bahia',
    value: 'BA',
  },
  {
    name: 'Ceará',
    value: 'CE',
  },
  {
    name: 'Distrito Federal',
    value: 'DF',
  },
  {
    name: 'Espirito Santos',
    value: 'ES',
  },
  {
    name: 'Goiás',
    value: 'GO',
  },
  {
    name: 'Maranhão',
    value: 'MA',
  },
  {
    name: 'Mato Grosso',
    value: 'MT',
  },
  {
    name: 'Mato Grosso do Sul',
    value: 'MS',
  },
  {
    name: 'Minas Gerais',
    value: 'MG',
  },
  {
    name: 'Pará',
    value: 'PA',
  },
  {
    name: 'Paraíba',
    value: 'PB',
  },
  {
    name: 'Paraná',
    value: 'PR',
  },
  {
    name: 'Pernambuco',
    value: 'PE',
  },
  {
    name: 'Piauí',
    value: 'PI',
  },
  {
    name: 'Rio de Janeiro',
    value: 'RJ',
  },
  {
    name: 'Rio Grande do Sul',
    value: 'RS',
  },
  {
    name: 'Rio Grande do Norte',
    value: 'RN',
  },
  {
    name: 'Rondônia',
    value: 'RO',
  },
  {
    name: 'Roraima',
    value: 'RR',
  },
  {
    name: 'Santa Catarina',
    value: 'SC',
  },
  {
    name: 'São Paulo',
    value: 'SP',
  },
  {
    name: 'Sergipe',
    value: 'SE',
  },
  {
    name: 'Tocantins',
    value: 'TO',
  },
];

export const months = [
  { label: 'Janeiro', value: '01' },
  { label: 'Fevereiro', value: '02' },
  { label: 'Março', value: '03' },
  { label: 'Abril', value: '04' },
  { label: 'Maio', value: '05' },
  { label: 'Junho', value: '06' },
  { label: 'Julho', value: '07' },
  { label: 'Agosto', value: '08' },
  { label: 'Setembro', value: '09' },
  { label: 'Outubro', value: '10' },
  { label: 'Novembro', value: '11' },
  { label: 'Dezembro', value: '12' },
];

export const daysOfWeek = [
  { name: 'domingo', shortName: 'dom', id: 1 },
  { name: 'segunda', shortName: 'seg', id: 2 },
  { name: 'terça', shortName: 'ter', id: 3 },
  { name: 'quarta', shortName: 'qua', id: 4 },
  { name: 'quinta', shortName: 'qui', id: 5 },
  { name: 'sexta', shortName: 'sex', id: 6 },
  { name: 'sábado', shortName: 'sab', id: 7 },
];

export const getIntervalNumbers = (init, end) => {
  const numbers = [];
  const length = init + end;

  for (let i = init; i <= length; i++) {
    numbers.push({ label: `${i}`, value: `${i}` });
  }

  return numbers;
};

export const formatToPhone = (str = '') => {
  if (str) {
    const replacedNumber = str.replace(/\d{2}/, '');
    const length = Math.round(replacedNumber.length / 2);
    const first = replacedNumber.slice(0, length);
    const last = replacedNumber.slice(length, replacedNumber.length);

    const number = [first, last].join('-');
    const ddd = str.match(/\d{2}/) ? str.match(/\d{2}/)[0] : '';

    return `(${ddd}) ${number}`;
  }

  return null;
};

export const redirect = (res, redirectTo, status = 302) =>
  res
    .writeHead(status, {
      Location: redirectTo,
      'Content-Type': 'text/html; charset=utf-8',
    })
    .end();

export const redirectTo404 = (res) => {
  res.statusCode = 404;
  redirect(res, '/404');
};

export const createSessionId = () => `${new Date().getTime()}.${Math.random()}`;

export const getCreditCardFlagName = (flag) => {
  if (flag) {
    return (flag.toLowerCase() !== 'amex' ? flag : 'american').toLowerCase();
  }

  return null;
};

/**
 * Função para formatar uma data em PT-BR.
 *
 * @param {(Date|Number)} date uma instância da classe Date ou timestamp,
 * se o parâmetro for omitido, o valor da data atual será usado.
 *
 * @returns {object} retorna uma objeto com o dia, mês, ano, dia da semana, hora, minuto, segundo e millissegundo.
 */
export function getPtDate(date = new Date()) {
  try {
    const current = format(date, 'E|dd-MMMM|MM-yyyy/HH:mm:ss:SSS', {
      locale: pt,
    });

    const [longDate, longTime] = current.split('/');

    const dateFormated = longDate.split('-');
    const timeFormated = longTime.split(':');

    const days = dateFormated[0].split('|');
    const monthsFormated = dateFormated[1].split('|');

    return {
      dayOfWeek: removeAccents(days[0]),
      day: days[1],
      month: monthsFormated[0],
      numberMonth: monthsFormated[1],
      year: dateFormated[2],
      hour: timeFormated[0],
      minutes: timeFormated[1],
      seconds: timeFormated[2],
      milliseconds: timeFormated[3],
    };
  } catch (error) {
    return {
      message: 'Data Inválida',
      error: true,
    };
  }
}

/**
 * Função para validação de data.
 *
 * @param {String} ptDate string no formato dd/MM/yyyy.
 *
 * @returns {Boolean} retorna true caso a data seja passado.
 */
export const validateDate = (ptDate) => {
  const valid = ptDate ? ptDate.replace(/[_]/g, '') : '';

  if (valid && valid.length === 10) {
    const date = parse(valid, 'dd/MM/yyyy', new Date());

    return isPast(date);
  }

  return false;
};

/**
 * Faz um link interno para um determinado elemento pelo attibuto 'id', scroll behavior.
 *
 * @param {String} id ID do elemento.
 * @param {Number} top Distância do topo que o scroll deve parar.
 *
 */
export function anchorTo(id, top = 0) {
  if (typeof window !== 'undefined') {
    const element = document.getElementById(id);

    if (!element) {
      return;
    }

    const y = element.getBoundingClientRect().top + window.pageYOffset - top;

    window.scrollTo({ top: y, behavior: 'smooth' });
  }
}

/**
 * Faz um replace silencioso na url sem reload.
 *
 * @param {String} asPath Rota que irá substituir a atual.
 *
 */
export function changeSilentlyURL(asPath) {
  window.history.replaceState(null, '', asPath);
}

export const formatParcel = (installment, noDescription = false) => {
  const description = installment.numeroParcelas === 1 ? 'à vista' : 'sem juros';

  return `${installment.numeroParcelas}x ${formatMoney(installment.valorParcelas)} = ${formatMoney(
    installment.valorParcelas === installment.valorTotal
      ? installment.valorParcelas * installment.numeroParcelas
      : installment.valorTotal
  )} ${!noDescription ? description : ''}`;
};

/**
 * Valida de endereço delivery do checkout é um endereço de loja.
 *
 * @param {Object} checkout Reducer checkout.
 *
 */
export const isStoreAddress = (checkout) =>
  !checkout.getIn(['addresses', 'addresses'], []).find((elm) => elm.id === checkout.getIn(['addressDelivery', 'id']));

export function generateBilletFile(file, filename) {
  const url = window.URL.createObjectURL(new Blob([file]));
  const link = document.createElement('a');

  link.href = url;
  link.download = `${filename}.pdf`;
  document.body.appendChild(link);
  link.click();

  setTimeout(function cb() {
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }, 300);
}

export function mergeSellerProducts(sellers) {
  const items = [];
  sellers.forEach((seller) => mergeLinesKits(seller.lines, seller.kits).forEach((item) => items.push(item)));

  return items;
}

export const templatesWidths = {
  A: 'unset',
  B: '1280px',
};

export default { removeAccents, slugify };
